import { useEffect, useState } from "react";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [time, setTime] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const update = () => {
      try {
        const t = new Intl.DateTimeFormat("en-US", {
          timeZone: "America/New_York",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }).format(new Date());
        setTime(`${t} NYC`);
      } catch {
        setTime("");
      }
    };
    update();
    const id = setInterval(update, 30_000);
    return () => clearInterval(id);
  }, []);

  const links = [
    { label: "Work", href: "#work" },
    { label: "About", href: "#about" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <nav
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-md bg-[#f6f3ed]/85 border-b border-black/10 text-black"
          : "bg-transparent text-black"
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-10 py-4 md:py-5">
        <a
          href="#top"
          className="font-display italic text-xl md:text-2xl tracking-tight link-underline"
          data-testid="nav-logo"
        >
          Mia<span className="text-neon-pink">·</span>Cho
        </a>

        <ul className="hidden md:flex items-center gap-8 font-mono text-xs uppercase tracking-[0.18em]">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="link-underline hover:text-neon-pink transition-colors"
                data-testid={`nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.22em] text-black/60">
          <span className="inline-block w-2 h-2 rounded-full bg-neon-lime animate-blink" />
          <span data-testid="nav-time">{time || "—"}</span>
        </div>

        <a
          href="#contact"
          data-testid="nav-cta"
          className="md:hidden font-mono text-[10px] uppercase tracking-[0.22em] border border-neon-pink text-neon-pink px-3 py-2"
        >
          Contact
        </a>
      </div>
    </nav>
  );
}
